// Dependecies
import { useState, useEffect } from 'react';
import { reject } from 'lodash';

// Store
import shop from '../../store/garageWorkShop';
import user from '../../store/user';

// Hooks
import useLanguage from '../useLanguage';

function useGarageWorkShops() {
  const { locale } = useLanguage();
  const [, shopActions] = shop();
  const [userStore] = user();
  const [shopOptions, setWorkShopOptions] = useState();
  const [shopDays, setWorkDays] = useState([]);
  const [sistems, setWorkSistem] = useState([]);
  const [brands, setWorkBrand] = useState([]);
  const [types, setWorkType] = useState([]);
  const [itemsistems, setWorkItemSistem] = useState([]);
  const [itembrands, setWorkItemBrand] = useState([]);
  const [itemtypes, setWorkItemType] = useState([]);
  const [garageWorkShops, setGarageWorkShops] = useState([]);
  const [reload, setReload] = useState(false);
  const [alertUpdate, setAlertUpdate] = useState(false);
  const [sendData, setSendData] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageAlert, setMessageAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classEditVenues, setClassEditVenues] = useState(true);
  const [classEditSistem, setClassEditSistem] = useState(true);
  const [classEditBrand, setClassEditBrand] = useState(true);
  const [classEditType, setClassEditType] = useState(true);
  const [classEditDays, setClassEditDays] = useState(true);
  const valueNull = 'no data';
  const days = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

  useEffect(() => {
    if (userStore.token) {
      shopActions.setVehicleSystem(userStore.token, locale).then(
        (system) => {
          setWorkItemSistem(system);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
      shopActions.setVehicleType(userStore.token, locale).then(
        (type) => {
          setWorkItemType(type);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
      shopActions.setBrand(userStore.token).then(
        (brand) => {
          setWorkItemBrand(brand);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );

      shopActions.setShops(userStore.token).then(
        (workShops) => {
          setWorkShopOptions(workShops.shops);
          const daysOfCaresJson = JSON.parse(workShops.shops.days_of_care);
          const daysOfCares = Object.values(daysOfCaresJson.Days);
          setWorkDays(daysOfCares);
          setWorkSistem(workShops.sistem);
          setWorkBrand(workShops.brand);
          setWorkType(workShops.type);
          setGarageWorkShops(workShops.garageWorkShops);
          setReload(true);
          setMessageAlert(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token, sendData]);

  const submit = (data) => {
    try {
      setLoading(true);
      const dataWorkShop = {
        garageWorkShops: data.garageWorkShopsInput,
        sistems: data.sistems,
        brands: data.brands,
        types: data.types,
        days: data.days,
        startTime: data.startTime,
        endTime: data.endTime,
        startTimeWeekend: data.startTimeWeekend,
        endTimeWeekend: data.endTimeWeekend,
      };
      shopActions.updateWorkShop(dataWorkShop, userStore.token).then(
        () => {
          setAlertUpdate(true);
          setSendData(true);
          setLoading(false);
        },
        (e) => {
          if (e.status === 401) {
            setMessageError(true);
            setSendData(true);
            setLoading(false);
          }
        }
      );
    } catch (error) {
      setMessageError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setAlertUpdate(false);
    }, 5000);

    return () => {
      clearTimeout(timer1);
    };
  }, [alertUpdate]);

  useEffect(() => {
    const timer2 = setTimeout(() => {
      setMessageAlert(false);
    }, 10000);

    return () => {
      clearTimeout(timer2);
    };
  }, [messageAlert]);

  useEffect(() => {
    const timer3 = setTimeout(() => {
      setMessageError(false);
    }, 5000);

    return () => {
      clearTimeout(timer3);
    };
  }, [messageError]);

  return {
    reload,
    shopOptions,
    shopDays,
    sistems,
    brands,
    types,
    garageWorkShops,
    itemsistems,
    itembrands,
    itemtypes,
    user: userStore.user,
    alertUpdate,
    messageError,
    messageAlert,
    loading,
    classEditVenues,
    classEditSistem,
    classEditBrand,
    classEditType,
    classEditDays,
    setClassEditVenues,
    setClassEditSistem,
    setClassEditBrand,
    setClassEditType,
    setClassEditDays,
    submit,
    setGarageWorkShops,
    setReload,
    valueNull,
    days,
  };
}

export default useGarageWorkShops;
